import * as React from 'react';
import { Card, CardContent, Button } from '@mui/material';
import { Title, UserIdentity, useGetIdentity } from 'react-admin';
import axios, { AxiosResponse } from 'axios';
import { superAdminApiServer } from '../../lib/config';
// 1. include the @flatfile/sdk  is installed with npm install @flatfile/sdk
import { Flatfile } from '@flatfile/sdk';
import { useEffect } from 'react';

// 3. a function to trigger `Flatfile.requestDataFromUser` to launch a Portal
export async function importFromFlatFile(portal: string, identity?: UserIdentity, googleIdToken?: string | null) {
  if (!identity) return;
  const res = await axios.get<unknown, AxiosResponse<any>, unknown>(`${superAdminApiServer}/admin/auth-flatfile`, { params: { portal: portal }, headers: { Authorization: `Bearer ${googleIdToken}` } });
  const { token } = res.data;
  Flatfile.requestDataFromUser({
    // Development mode = embedId, user, org.
    token,
    // handle submitted data
    onData(chunk, next) {
      // do something with the data
      console.log(chunk);
      // call next() to proceed with the import
      next();
    },
    onComplete() {
      console.log(`Import complete`);
    },
    onError(error) {
      console.error(error);
    }
  });
}

const ImportSchedulesButton = () => {
  const { identity } = useGetIdentity();
  const token = localStorage.getItem('GoogleIdToken');
  useEffect(() => {
    console.log(identity);
  }, [identity]);
  return (
    <>
      <Button onClick={() => importFromFlatFile('schedules', identity, token)}>Import Schedules</Button>
    </>
  );
};
const ImportHolidayGroupsButton = () => {
  const { identity } = useGetIdentity();
  const token = localStorage.getItem('GoogleIdToken');
  useEffect(() => {
    console.log(identity);
  }, [identity]);
  return (
    <>
      <Button onClick={() => importFromFlatFile('holidayGroups', identity, token)}>Import Holiday Groups</Button>
    </>
  );
};

const ImportBusinessRuleGroupsButton = () => {
  const { identity } = useGetIdentity();
  const token = localStorage.getItem('GoogleIdToken');
  useEffect(() => {
    console.log(identity);
  }, [identity]);
  return (
    <>
      <Button onClick={() => importFromFlatFile('businessRuleGroups', identity, token)}>Import Business Rules</Button>
    </>
  );
};
const CSToolsList = () => {
  return (
    <>
      <br />
      <Title title="CS TOOLS" />
      <Card>
        <CardContent>
          <ImportSchedulesButton />
        </CardContent>
      </Card>
      <br />
      <Card>
        <CardContent>
          <ImportBusinessRuleGroupsButton />
        </CardContent>
      </Card>
      <br />
      <Card>
        <CardContent>
          <ImportHolidayGroupsButton />
        </CardContent>
      </Card>
    </>
  );
};

export default CSToolsList;
